import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import React, { useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import TextInput from '~components/FormFields/v2/TextInput';

const schema = yup.object().shape({ name: yup.string().required() });

interface FuelPriceIndexFormData {
  name: string;
}

interface FuelPriceIndexFormProps {
  initialValues?: FuelPriceIndexFormData;
}

export interface FuelPriceIndexFormHandler {
  submit: () => Promise<FuelPriceIndexFormData | undefined>;
}

const FuelPriceIndexForm = React.forwardRef<
  FuelPriceIndexFormHandler,
  FuelPriceIndexFormProps
>(({ initialValues }, ref) => {
  const { control, handleSubmit } = useForm<FuelPriceIndexFormData>({
    defaultValues: initialValues ?? {
      name: '',
    },
    resolver: yupResolver(schema),
  });

  useImperativeHandle(
    ref,
    () => ({
      submit: () => {
        return new Promise<FuelPriceIndexFormData | undefined>((resolve) => {
          handleSubmit((data) => {
            resolve(data);
          })();
        });
      },
    }),
    [handleSubmit],
  );

  return (
    <Box>
      <TextInput
        control={control}
        isRequired
        label={t('administration.fuel_price_index.form_name_label')}
        name="name"
        sx={{ gridColumn: 'span 3' }}
      />
    </Box>
  );
});

FuelPriceIndexForm.displayName = 'FuelPriceIndexForm';

export default FuelPriceIndexForm;
